<template>
  <div class="d-flex align-items-baseline">
    <div class="user-name me-1">
      <a
          v-if="comment && comment.userid"
          target="_blank"
          rel="noreferrer noopener"
          :title="'E-Mail an '  + username +  ' senden'"
          :href="sanitizeUrl('mailto:' + comment.userid.toLowerCase())">
        {{username}}
      </a>
      <span v-if="!comment || !comment.userid">
        {{username}}
      </span>
    </div>
    <div class="user-name-time">•</div>
    <div
        class="user-name-time ms-1"
        :title="getTimeString((comment && comment.timestamp) || '')" >
      {{getFromNowString((comment && comment.timestamp) || '')}}
    </div>
    <div v-if="showDeleteButton" class="user-name-time ms-auto d-flex">
      <button
          class="btn btn-mini comment-trash-button"
          title="Kommentar löschen"
          @click="askDeleteComment"
      >
        <i class="fa-trash-alt fa-xs far" aria-hidden="true"></i><span class="sr-only">Kommentar löschen</span>
      </button>
    </div>
  </div>
  <modal-dialog
      v-if="showConfirmDeleteModal"
      buttonTextConfirm="Kommentar löschen"
      buttonTextCancel="Abbrechen"
      @confirm="deleteComment"
      @cancel="showConfirmDeleteModal = false" >
    <template v-slot:header></template>
    <template v-slot:body>Sind Sie sicher, dass dieser Kommentar gelöscht werden soll?</template>
  </modal-dialog>
  <div v-if="showDeleteError" class="error-information">
    <p>
      <strong>Fehler:</strong> Beim Löschen des Kommentars ist ein unerwarteter Fehler aufgetreten.
    </p>
  </div>
  <!-- Kommentarinhalt: -->
  <p :class="bodyClass" v-html="commentTextSanitized"></p>

</template>
<script lang="ts">


import { defineComponent } from 'vue'
import moment from 'moment';
import meService from '@/services/meService';
import commentService from '@/services/commentService';
import { Comment } from '@/generated/openapi';
import ModalDialog from '../common/ModalDialog.vue';
import { sanitizeHtml } from '../../utils/domUtils';
import { sanitizeUrl } from '@braintree/sanitize-url';


export default defineComponent({
  name: 'CommentCard',
  components: {ModalDialog},
  props: {
    comment: {
      type: Object as () => Comment
    },
    forceShowDeleteCommentButtons: Boolean,
  },
  emits: ['commentDeleted'],
  data() {
    return {
      showDeleteButton: false,
      showConfirmDeleteModal: false,
      showDeleteError: false,
      sanitizeUrl: sanitizeUrl
    };
  },
  mounted() {
    this.isDeleteButtonShown().then((x) => {this.showDeleteButton = x})
    moment.locale('de');
  },
  updated() {
    this.isDeleteButtonShown().then((x) => {this.showDeleteButton = x})
  },
  computed: {
    username():string {
      if ( this.comment?.username !== undefined && this.comment.username.length > 0) {
        return this.comment.username
      } else if (this.comment?.userid !== undefined && this.comment.userid.length > 0) {
        return this.comment.userid
      }
      return "[Benutzer unbekannt]"
    },
    commentTextSanitized():string {
      if (this.comment?.deleted === true) {
        return "Dieser Kommentar wurde gelöscht."
      } else if (this.comment && this.comment.body) {
        let tmpBody = this.comment.body
        if (tmpBody.length > 2000) {
          tmpBody = tmpBody.substring(0, 1990) + "<br>[...]"
        }

        tmpBody = this.comment.body
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;')
          // Replace newlines with html <br>
          .replace(/(?:\r\n|\r|\n)/g, '<br>');

        while (tmpBody.indexOf('<br><br><br><br>') >= 0) {
          // Remove excessive breaks (max 2 empty lines)
          tmpBody = tmpBody.replaceAll('<br><br><br><br>', '<br><br><br>')
        }

        return sanitizeHtml(tmpBody)
      }
      return ''
    },
    bodyClass():string {
      if (this.comment !== undefined && this.comment.deleted === true) {
        return "deleted-comment"
      } else {
        return ""
      }
    }
  },
  methods: {
    askDeleteComment(): void {
      this.showDeleteError = false
      this.showConfirmDeleteModal = true
    },

    deleteComment(): void {
      this.showDeleteButton = false
      this.showConfirmDeleteModal = false
      if (this.comment?.threadid !== undefined && this.comment.id !== undefined) {
        commentService.deleteOrMarkDeleted(this.comment.threadid, this.comment.id).then((resp) => {
          if(resp.success) {
            this.showDeleteButton = false
            this.showDeleteError = false
            this.$emit('commentDeleted')
          } else {
            this.showDeleteButton = true
            this.showDeleteError = true
          }
        }).catch(() => {
          this.showDeleteButton = true
          this.showDeleteError = true
          this.$emit('commentDeleted')
        })
      }

    },

    getFromNowString(timestamp:string): string {
      moment.locale('de');
      return moment(timestamp, 'X').fromNow();
    },

    getTimeString(timestamp:string): string {
      moment.locale('de');
      return moment(timestamp, 'X').format('DD.MM.YYYY, HH:mm:ss');
    },

    isDeleteButtonShown (): Promise<boolean> {
      if (this.comment?.deleted === true) {
        // if (this.comment.replies === undefined || this.comment.replies.length === 0) {
        //   // Kommentar wurde zuvor als gelöscht markiert. jetzt sind keine Antworten mehr da. er kann gelöscht werden.
        //   return Promise.resolve(true)
        // }
        // Kommentar wurde bereits als gelöscht markiert, und es sind noch antworten da.
        return Promise.resolve(false)
      } else if (this.forceShowDeleteCommentButtons) {
        return Promise.resolve(true);
      } else {
        return meService.getMe().then((me) => {
          if (me?.email !== undefined) {
            // only enable case-insensitivity if LFRZBIN-261 is solved
            if (me?.email?.toUpperCase() === this.comment?.userid?.toUpperCase()) {
            // if (me?.email === this.comment?.userid) {
              return true
            }
          }
          return false
        }).catch(() => {
          return false
        })
      }
    },

  }


});

</script>
<style scoped>
  button.comment-trash-button {
    padding: 0px;
    border: none;
    background-color: transparent;
  }
  p.deleted-comment {
    color: gray;
  }
  div.error-information {
    background-color: #ffdbdb;
    padding: 5px;
  }
</style>
